export default __webpack_public_path__ + "static/media/2-3_image2.09384490.png";